import querystring from 'querystring';

import { FORGOT_PASSWORD } from './hashRoutes';

export const composeUrl = (emailAddress: string) => {
  const [, searchString = ''] = (window.location.search ?? '').split(/\?(.+)/);
  const [, fragment = ''] = (window.location.hash ?? '').split(/\?(.+)/);

  const searchParams = querystring.parse(searchString);
  const fragmentParams = querystring.parse(fragment);

  searchParams.login_msg = 'error.expired_password';
  fragmentParams.login_msg = 'error.expired_password';
  if (emailAddress) fragmentParams.email_hint = emailAddress;

  const filteredSearch = querystring.stringify(searchParams);
  const filteredFragment = querystring.stringify(fragmentParams);
  return `${window.location.origin}${
    window.location.pathname ?? ''
  }?${filteredSearch}#${FORGOT_PASSWORD}?${filteredFragment}`;
};
